var map = {
	"./sticker_cute_balloon_purple.png": 551,
	"./sticker_cute_bear_brown.png": 1571,
	"./sticker_cute_bow_yellow.png": 1392,
	"./sticker_cute_cat_blue.png": 2477,
	"./sticker_cute_cloud_blue.png": 8157,
	"./sticker_cute_clover_green.png": 9022,
	"./sticker_cute_crown_gold.png": 5065,
	"./sticker_cute_flower_pink.png": 7494,
	"./sticker_cute_fox_orange.png": 5203,
	"./sticker_cute_frog_green.png": 2914,
	"./sticker_cute_heart_red.png": 8881,
	"./sticker_cute_house.png": 4128,
	"./sticker_cute_rabbit_pink.png": 3387,
	"./sticker_cute_ribbon_pink.png": 9148,
	"./sticker_cute_smile_yellow.png": 1282,
	"./sticker_cute_sparkle_blue.png": 1140,
	"./sticker_cute_sparkle_pink.png": 4071,
	"./sticker_cute_speech_bubble_purple.png": 1773,
	"./sticker_cute_star_yellow.png": 2728,
	"./sticker_cute_tulip_orange.png": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6122;